module.exports = __webpack_public_path__ + "img/login-icon-service.72ff8524.png";